module.exports = __webpack_public_path__ + "photo-25fda29b6ab5eed2bbca.svg";